import type { ReactNode } from "react";

export function MetaItem({
  label,
  value,
}: {
  label: string;
  value: ReactNode;
}) {
  return (
    <div className="min-w-0 rounded-lg bg-white/70 px-2.5 py-2 dark:bg-black/10">
      <div className="text-[10px] font-semibold tracking-wide text-stone-400 uppercase">
        {label}
      </div>
      <div className="mt-0.5 truncate text-xs font-semibold text-stone-700 dark:text-stone-200">
        {value}
      </div>
    </div>
  );
}
